// extracted by mini-css-extract-plugin
export default {"mainDiv":"UploadErrorPopup_mainDiv__CfE3V","container":"UploadErrorPopup_container__0rkz8","button":"UploadErrorPopup_button__QQqw6"};